import RestAPI from '../../components/Common/restApi';

export default class FranchiseeApi {
  static index() {
    return RestAPI.get('/alpha/franchisees');
  }

  static org_index() {
    return RestAPI.get('/alpha/franchisees?org=true');
  }

  static create_session(organization_id) {
    return RestAPI.postWithFormData('/alpha/franchisee_sessions', { organization_id: organization_id });
  }
}
